import React from 'react';

import { Button } from '@sequencing/design-system';
import ArrowCircle from '../../../../images/ArrowCircle.svg';

import './DnaDayHolidayBanner.css';

const DnaDayHolidayBanner = () => {
  return (
    <a
      className="link"
      href="http://get.sequencing.com/dna-day-2025/?utm_source=website&utm_medium=top-banner&utm_campaign=dnaday&utm_content=t"
    >
      <div className={'dnaDayHolidayBanner'}>
        <div className={'dnaDayHolidayBannerContent'}>
          <span>DNA DAY SPECIAL SALE!</span>{' '}
          <span>65% Off + Free Shipping</span>
        </div>
        <div className={'dnaDayHolidayBannerAction'}>
          <Button variant={'outlinedWhite'} label={'Order Now'} />
          <img alt={''} src={ArrowCircle} width={24} height={24} />
        </div>
      </div>
    </a>
  );
};

export default DnaDayHolidayBanner;
